module.exports = __webpack_public_path__ + "static/media/taste_of_nusantara.2970e38c.jpeg";